import { GridSortModel } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../hooks/use-encounter-creation-gate";
import { PatientVaccineControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  patientUuid?: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortModel;
  status?: boolean;
  archive?: boolean;
  searchString?: string;
  xTENANTID?: string | undefined;
  appointmentId?: string;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientVaccinesList = ({
  patientUuid,
  pagination,
  gridSorting,
  status,
  archive,
  searchString,
  appointmentId,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "patient-vaccine-list",
      xTENANTID,
      pageIndex,
      appointmentId,
      patientUuid,
      pageSize,
      gridSorting,
      sortData,
      status,
      archive,
      searchString,
      xTENANTID,
      sortData,
    ],
    enabled: enabled && !skip,
    refetchOnWindowFocus: false,

    queryFn: async () =>
      await new PatientVaccineControllerApi(getConfigObject())
        .getPatientVaccines(
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, // sortDirection
          status,
          archive,
          patientUuid,
          appointmentId,
          searchString,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
